<template>
  <div class="columnarEchart" :style="{height:height,width:width}" ref="columnarEchart"></div>
</template>

<script>
import echarts from 'echarts'
import { setTimeout } from 'timers';
require('echarts/theme/macarons')  // echarts 马卡龙主题

export default {
  props: {
    width: {
      type: String,
      // default: '100%'
      // default: 'calc(100% - 227px)'
      default: 'calc(100% - 127px)'
    },
    height: {
      type: String,
      default: '174px'
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.initChart()
    window.onresize = this.chart.resize
  },
  methods: {
    initChart() {
        // this.chart = echarts.init(this.$refs.columnarEchart, 'macarons')
        this.chart = echarts.init(this.$refs.columnarEchart)
        // 柱状图配置和数据
        var option = ({
            color: ['#B2DF8A','#D4DF8A'],
            tooltip: {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{c}'
                // formatter: '{b}: {c}'
                //formatter: 柱状（条形）图: {a}（系列名称），{b}（类目值），{c}（数值）, {d}（无）
            },
            grid: {
                left: '4.5%',
                right: '1%',
                bottom: '2%',
                top: '30',
                containLabel: true
            },
            xAxis: { //横坐标
                type: 'category',
                data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
            },
            yAxis: {
                type: 'value'
            },
            series: [{//纵坐标数据
                type: 'bar',
                barWidth: '20',
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ]
            }]
        })

        this.chart.setOption(option)
        window.onresize = this.chart.resize // 随屏幕的改变自适应大小
    },

    // 获取数据渲染图形
    getDataAndDraw (xAxisData, serviceData) {
      // console.log('xAxisData', xAxisData)
      // console.log('serviceData', serviceData)

      setTimeout(() => {
        this.chart.setOption({
            xAxis: {
                data: xAxisData
            },
            series: [{
                data: serviceData,
            }]
        })
      }, 100);
      
    }

  },
  created () {
    // this.getDataAndDraw()
  },
  
}
</script>

<style scoped>
  .columnarEchart{
    /* width: 78%; */
    /* width: 100%; */
    height: 144px;
    margin-right: 15px;
    display: inline-block;
  }
</style>
